<script lang="ts">
    import PersonTeaser from "../PersonTeaser.svelte"
    import { getPersonen } from "../../api"

    export let data: Person[] = []

    getPersonen(true).then((r) => {
        data = r
    })
</script>

<div class="list collection">
    {#each data as person}
        <PersonTeaser person="{person}" />
    {/each}
</div>

<style lang="less">
    @import "../../css/base.less";

    .list {
        .flex();
        flex-wrap: wrap;
        margin: -15px;
    }
</style>
